export const index = () => require.ensure([], () => require("./index.vue"), "index");